import type { ReactNode } from 'react';
import { CircularProgress } from '~/common/components/CircularProgress';
import { cn } from '~/common/utils/styleUtil';
import EmptySearchResult from '~/common/components/EmptySearchResult';
import { Virtuoso } from 'react-virtuoso';

export interface IVirtualBaseListProps {
  itemCount: number;
  renderItem: (data: IVirtualBaseListRenderItemProps) => ReactNode;
  useWindowScroll?: boolean;
  testId?: string;
  isLoading?: boolean;
  noItemsMessage?: string;
  endReached?: (index: number) => void;
  className?: string;
  overscan?:  number | {
    main: number;
    reverse: number;
  }
  height?: number | string;
}

export interface IVirtualBaseListRenderItemProps {
  index: number;
}

type Props = IVirtualBaseListProps;

export function VirtualBaseList({
  overscan = {
    main: 500,
    reverse: 500
  },
  className,
  endReached,
  testId,
  itemCount,
  renderItem,
  useWindowScroll = true,
  isLoading,
  noItemsMessage = '',
  height
}: Readonly<Props>) {
  if (isLoading) {
    return <CircularProgress />;
  }

  if (noItemsMessage && (!itemCount || itemCount === 0)) {
    return <EmptySearchResult message={noItemsMessage} />;
  }

  return (
    <div data-testid={testId} className={cn('pt-0 pb-0', className)}>
      <Virtuoso
        overscan={overscan}
        endReached={endReached}
        useWindowScroll={useWindowScroll}
        totalCount={itemCount}
        itemContent={(index: number) => renderItem({ index })}
        style={useWindowScroll ? {} : { height: height }}
      />
    </div>
  );
}
